import { useState } from 'react';
import axios from 'axios';
import V2Message from 'src/common/components/Others/V2Hint/V2Message';

/**
 * @description: 上传 blob 文件到七牛云
 * @param params.token 七牛 token
 * @param params.domain 七牛文件域名前缀
 * @param params.actionUrl 上传七牛的地址
 * @return {*}
 * @demo
this.uploadData = new UploadBlobToQiniu({ token: this.uploadDataToken, domain: this.qiniuDomain, actionUrl: this.actionUrl });
console.log('this.uploadData', this.uploadData);
await this.uploadData.start(blob);
 */
function useUploadBlobToQiniu({ token, domain, actionUrl }: { token: string, domain: string, actionUrl: string }) {

  const _options = Object.assign({}, { token, domain, actionUrl });
  const [data, setData] = useState<any>({
    name: null,
    url: null,
    percent: 0, // 进度：包括上传图片和返回结果
  });

  // 重置数据
  const reset = () => {
    // 如果直接赋值会切断引用
    setData({
      name: null,
      url: null,
      percent: 0, // 进度：包括上传图片和返回结果
    });
  };

  // 开始上传 base64 到七牛
  const start = (blob) => {
    reset();

    const formData = new FormData(); // 创建form对象
    formData.append('chunk', '0'); // 断点传输
    formData.append('chunks', '1');
    // formData.append('file', file, file.name);
    formData.append('file', blob);
    formData.append('token', _options.token);

    return axios({
      method: 'post',
      url: _options.actionUrl,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: evt => {
        // 上传进度
        if (evt.lengthComputable) {
          // 上传后还要等待返回结果
          setData(state => ({ ...state, percent: Math.round((evt.loaded * 100) / evt.total) - 10 }));
        } else {
          V2Message.warning('无法获取上传进度');
        }
      },
    }).then(response => {
      const name = `${+new Date()}.png`;
      const url = `${_options.domain}/${response.data.key}`;
      setData(state => ({ ...state, name, url }));
      return { name, url };
    }).catch(err => {
      V2Message.error('上传出错，请重试');
      // 抛出错误（重新获取token）
      return Promise.reject(err);
    }).finally(() => {
      setData(state => ({ ...state, percent: 100 }));
    });
  };

  return { reset, start, ...data };
};

export default useUploadBlobToQiniu;
